import React, { useEffect, useState } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import s from './IntroSectionDesktop.css';
import TabPanel from 'common/components/TabPanel/TabPanel';

export default function IntroSectionDesktop({ items }) {
  const [value, setValue] = useState(0);

  useStyles(s);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const updateValue = () => {
    setValue((prev) => (prev + 1) % items.length);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      updateValue();
    }, 20000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <section>
      <h2>ارزش‌های تپسی</h2>
      <div className={s.valuesContainer}>
        <div>
          {items.map((item, index) => (
            <TabPanel value={value} index={index}>
              <div className={s.valueTab}>
                <div>
                  <picture>
                    <source srcSet={item.webpImage} type="image/webp" />
                    <source srcSet={item.jpgImage} type="image/jpg" />
                    <img src={item.jpgImage} alt={item.alt} width="90%" />
                  </picture>
                </div>
                <div className={s.contentContainer}>
                  <h3 className={s.valueTitle}>{item.title}</h3>
                  <p className={s.description}>{item.text}</p>
                </div>
              </div>
            </TabPanel>
          ))}
        </div>
        <div className={s.tabContainer}>
          {items.map((item, index) => (
            <Button className={`${index === value ? s.activeTab : ''} ${s.tab}`} onClick={(e) => handleChange(e, index)}>
              {item.name}
            </Button>
          ))}
        </div>
      </div>
    </section>
  );
}

IntroSectionDesktop.propTypes = {
  items: PropTypes.array.isRequired,
};
